module.exports = __webpack_public_path__ + "static/media/closeicon.6dbf9a2f.svg";